<a class="sr-only" href="#main-content">Μετάβαση στο κύριο περιεχόμενο</a>
<div class="layout-container" [ngClass]="containerClass">
  <app-topbar></app-topbar>
  <app-config></app-config>
  <main class="layout-content-wrapper" id="main-content" tabindex="-1">
    <div class="layout-content">
      <app-breadcrumb></app-breadcrumb>
      <lib-loading-spinner></lib-loading-spinner>
      <router-outlet></router-outlet>
      <lib-talkjs-chat></lib-talkjs-chat>
    </div>
  </main>
  <app-profilemenu></app-profilemenu>

  <div class="layout-mask"></div>
</div>
